import React from 'react';

class SelectAStoreMap extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onScriptLoad = this.onScriptLoad.bind(this);
  }

  onScriptLoad() {
    const map = new window.google.maps.Map(
      document.getElementById(this.props.id),
      this.props.options,
    );
    this.props.onMapLoad(map);
  }

  componentDidMount() {
    const { mapsKey } = this.props;
    if (!window.google) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = `https://maps.google.com/maps/api/js?key=${mapsKey}`;
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
      // Below is important.
      // We cannot access google.maps until it's finished loading
      s.addEventListener('load', e => {
        this.onScriptLoad();
      });
    } else {
      this.onScriptLoad();
    }
  }

  componentDidUpdate(prevProps) {
    const { stores: prevStores } = prevProps;
    const { stores: newStores } = this.props;
    if (newStores != prevStores) {
      this.onScriptLoad();
    }
  }

  render() {
    return (
      <div
        id={this.props.id}
        ref={ref => {
          this.mapRef = ref;
        }}
      />
    );
  }
}

export default SelectAStoreMap;
